import { put, takeLatest, select } from 'redux-saga/effects';
import { actionStatus, getError, statusAction } from '../utils';
import { BATCH_REPORT_EXPORT_SEND_REQUEST, BATCH_REPORT_EXPORT_SEND_EXPORT_REQUEST_MACHINES } from './constants';
import { addNotification } from '../ui/notifications/actions';
import { generateId } from '../../helpers/utils';
import { NOTIFICATION_TYPE_INTERACTION } from '../../attrs/notifications';
import { putBatchReportExports } from '../../api/batch_report_exports';
import { showBatchReportExportModal } from './actions';
import { getUserInfo } from '../user/selectors';

function* requestBatchReportExport({ req, action }) {
  yield put(statusAction(BATCH_REPORT_EXPORT_SEND_REQUEST, actionStatus.START));
  try {
    let ok = false;
    let successMessage = '';
    let res = null;
    let modifyReq = null;
    switch (action) {
      case BATCH_REPORT_EXPORT_SEND_EXPORT_REQUEST_MACHINES:
        modifyReq = {
          ...req
        };

        delete modifyReq.batchId;

        res = yield putBatchReportExports(req.batchId, modifyReq);

        successMessage = 'report_success_message';
        if (res.status !== 200) {
          yield put(
            addNotification({
              key: generateId(),
              type: actionStatus.ERROR,
              message: `errors.batch_record.report`,
              notificationType: NOTIFICATION_TYPE_INTERACTION
            })
          );
          return;
        }
        ok = true;
        break;
      default:
        yield put(
          addNotification({
            key: generateId(),
            type: actionStatus.ERROR,
            message: `errors.alerts.denied`,
            notificationType: NOTIFICATION_TYPE_INTERACTION
          })
        );
        break;
    }

    if (ok) {
      const { user } = yield select(getUserInfo);
      yield put(statusAction(BATCH_REPORT_EXPORT_SEND_REQUEST, actionStatus.SUCCESS, { payload: req }));
      yield put(
        addNotification({
          key: generateId(),
          type: actionStatus.SUCCESS,
          message: `dialog.batch_record.${successMessage}`,
          variables: [{ name: 'email', data: user.data['e-mail'] }],
          notificationType: NOTIFICATION_TYPE_INTERACTION
        })
      );
      yield put(showBatchReportExportModal(false));
    }
  } catch (err) {
    const error = getError(err);
    yield put(
      statusAction(BATCH_REPORT_EXPORT_SEND_REQUEST, actionStatus.ERROR, {
        message: error
      })
    );
    yield put(
      addNotification({
        key: generateId(),
        type: actionStatus.ERROR,
        message: `errors.generic`,
        notificationType: NOTIFICATION_TYPE_INTERACTION
      })
    );
  }
}

export function* watchLoadOrders() {
  yield takeLatest(BATCH_REPORT_EXPORT_SEND_REQUEST, requestBatchReportExport);
}
